import { render, staticRenderFns } from "./BlocoDadosTerritorioMonitoramentoSocioambientalParaguai.vue?vue&type=template&id=50aaceb5&scoped=true&lang=pug"
import script from "./BlocoDadosTerritorioMonitoramentoSocioambientalParaguai.vue?vue&type=script&lang=js"
export * from "./BlocoDadosTerritorioMonitoramentoSocioambientalParaguai.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosTerritorioMonitoramentoSocioambientalParaguai.vue?vue&type=style&index=0&id=50aaceb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aaceb5",
  null
  
)

export default component.exports